import styled from 'vue-styled-components';
import { LogoItem, LogoWrap } from './LogoItem';
import Vue from 'vue';

import { Overlay, SurfaceOverlay } from '@/components/UI/Material/Overlay';

const ItemProps = {
  disabled: Boolean,
  size: String,
};
const RouterLink = Vue.component('router-link');

const Title = styled('div', {})`
  color: var(--on_surface);
  font-size: 14px;
  width: 100%;
  opacity: 0.8;
  overflow-wrap: break-word;
  &:hover {
    opacity: 1;
  }
`;
const GridItem = styled('div', ItemProps)`
    width: ${props => props.size}; 
    height: ${props => props.size};
    
    color: var(--on_surface);
    background: var(--surface);

       
    border: var(--border);
    border-radius: var(--border_radius);
    box-shadow: var(--box_shadow);
    border-color: var(--border_color);
   
   
    &:hover {
            box-shadow: var(--box_shadow_hover);
            .grid_item__title {
                opacity: 1;
            }
            .grid_item__overlay {
                  opacity: .03;
            }
     }
    &:active {
            box-shadow: var(--box_shadow_inset);
            background-color: var(--secondary_background_color);
    }
   
    cursor: pointer;
    transition: box-shadow 0.3s;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    position: relative;
    padding: 11px;
    margin: 10px 0 10px 20px;
    text-decoration: none;
    box-sizing: border-box; lighten($linkcolour, 50%);
   
   ${props => props.theme.min1000`
     &:nth-child(6n+1) {
          margin-left: 0 !important;
        }
   `} 
   ${props => props.theme.max556`
       :nth-child(2n+1) {
              margin-left: 0 !important;
        }
    `}
    ${props => props.theme.min557max733`
       :nth-child(2n+1) {
              margin-left: 0 !important;
        }
    `}
    ${props => props.theme.min734max850`
       :nth-child(4n+1) {
          margin-left: 0 !important;
       }
    `}
    
    ${props =>
      props.disabled
        ? `{
            opacity: 0.3;
            pointer-events: none;
     }`
        : null}
    
    .payment-methods__icon-wrap {
        margin-left: auto;
        height: 21px;
        position: absolute;
        top: 10px;
        right: 10px;
    .payment-methods__icon {
            line-height: 1.25;
            padding: 3px 5px 0 4px;
            margin-bottom: 4px;
            border: solid 1px;
        }

    .payment-methods__icon--blue {
            color: #0055cc;
            border-color: rgba(0, 85, 204, 0.25);
        }

    .payment-methods__icon--green {
            color: #13bf4d;
            border-color: rgba(19, 191, 76, 0.25);
        }

    .payment-methods__icon--grey {
            color: #b4b5b8;
            border-color: rgba(215, 217, 220, 0.5);
        }
    }

`;

GridItem.overlay = SurfaceOverlay;
GridItem.logo = LogoItem;
GridItem.logoWrap = LogoWrap;
GridItem.Title = Title;

export default GridItem;
